import { Link } from "react-router-dom";
import iconSource from "../assets/branding/icon-source.png";
import logoHorizontal from "../assets/branding/logo-horizontal.png";

// icon-source.png has its own navy background baked in, so it's safe on any
// surrounding color. logo-horizontal.png has a solid WHITE background baked
// in, so it can only be used where the page behind it is already light —
// on a colored/dark surface (variant="dark") we fall back to the icon plus
// a code-drawn wordmark instead of showing the white-boxed image.
export default function Logo({ variant = "dark", size = "md", showWordmark = true }) {
  const px = size === "sm" ? 28 : size === "lg" ? 44 : 34;
  const isDark = variant === "dark";

  if (!isDark && showWordmark) {
    const h = size === "sm" ? 24 : size === "lg" ? 36 : 30;
    return (
      <Link to="/" className="inline-flex items-center group" data-testid="mm-logo">
        <img
          src={logoHorizontal}
          alt="MoneyMeet Pay"
          style={{ height: h, width: "auto" }}
          className="transition-transform group-hover:-translate-y-[1px]"
        />
      </Link>
    );
  }

  return (
    <Link to="/" className="inline-flex items-center gap-2.5 group" data-testid="mm-logo">
      <img
        src={iconSource}
        alt="MoneyMeet Pay"
        style={{ width: px, height: px }}
        className="rounded-xl transition-transform group-hover:-translate-y-[1px]"
      />

      {showWordmark && (
        <span className="flex flex-col leading-none">
          <span
            className={`font-display font-bold tracking-tight text-white ${
              size === "lg" ? "text-2xl" : "text-lg"
            }`}
          >
            MoneyMeet
          </span>
          <span className="text-[10px] uppercase tracking-[0.18em] mt-0.5 text-emerald">
            Pay
          </span>
        </span>
      )}
    </Link>
  );
}
